import { INotificationState } from '../types';
import { AT_ACTIVE_NOTIFICATION_UPDATE, AT_RECENT_NOTIFICATION_UPDATE } from '../actions/constants';
import { TNotificationAction } from '../actions/types';

const initialState: INotificationState = {
    activeNotification: null,
    recentNotification: null
};

export const notificationsReducer = (
    state = initialState,
    action: TNotificationAction
): INotificationState => {
    switch (action.type) {
        case AT_ACTIVE_NOTIFICATION_UPDATE: {
            return {
                ...state,
                ... {
                    activeNotification: action.activeNotification
                }
            };
        }
        case AT_RECENT_NOTIFICATION_UPDATE: {
            return {
                ...state,
                ...{
                    recentNotification: action.recentNotification
                }
            };
        }
        default:
            return state;
    }
};
